import React, { Component } from "react";
import { Page } from "./Pages";

export default class AboutUs extends Component {
    constructor() {
        super();
        this.state = {
            loading: true,
            error: "",
            name: "about",
            title: null,
            content1: null,
            content2: null,
        };
    }

    loadData() {
        this.setState({ loading: true });

        const headers = {
            "Content-Type": "application/json",
        };

        const that = this;
        return axios
            .get(`/api/pages/${this.state.name}`, headers)
            .then((response) => {
                that.setState({
                    title: response.data.data.title,
                    content1: response.data.data.content1,
                    content2: response.data.data.content2,
                    loading: false,
                    error: false,
                });
            })
            .catch(function (error) {
                that.setState({
                    loading: false,
                    error: `${error}`,
                });
            });
    }

    componentDidMount() {
        this.loadData();
    }

    render() {
        const { loading, error, name, title, content1, content2 } = this.state;
        if (error) {
            return (
                <Page
                    name={name}
                    title={error}
                    content1={content1}
                    content2={content2}
                />
            );
        } else if (loading) {
            return (
                <Page
                    name={name}
                    title="Loading..."
                    content1={content1}
                    content2={content2}
                />
            );
        } else {
            return (
                <Page
                    name={name}
                    title={title}
                    content1={content1}
                    content2={content2}
                />
            );
        }
    }
}
